import { render, staticRenderFns } from "./CreatorRuleIndex.vue?vue&type=template&id=7836a848&"
import script from "./CreatorRuleIndex.vue?vue&type=script&lang=js&"
export * from "./CreatorRuleIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports